import { Component, ReactNode } from 'react';

import { twclsx } from 'utils/twclsx';

interface LabelProps {
    children: ReactNode;
    className?: string;
}

interface LabelState {}

export default class Label extends Component<LabelProps, LabelState> {
    constructor(props: LabelProps) {
        super(props);
        this.state = {};
    }

    render() {
        const { children, className } = this.props;
        return (
            <label className={twclsx('block', 'capitalize', 'text-gray-500', 'font-bold', 'mb-1', className)}>
                {children}
            </label>
        );
    }
}
